import { DocumentEditValidationConfiguration } from '../types/private';
import { nullErrorRenderer } from '../ErrorRenderer';

export const createNullConfiguration: () => DocumentEditValidationConfiguration = () => ({
    fieldNamesToValidateOnFocusLoss: [],
    validationFunctions: [],
    eventsToValidateOn: [],
    errorRenderer: nullErrorRenderer,
});
